import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { useTranslation } from "../../components/WithTranslation/src/I18n";

interface IMultiLobIndicationProps {
    sector: string;
}

const primaryText = "conversion.website.multi.lob.disclaimer.primary.label";
const secondaryText = "conversion.website.multi.lob.disclaimer.secondary.label";

export const MultiLobIndication = ({ sector }: IMultiLobIndicationProps) => {
    const translate = useTranslation();

    return (
        <MultiLobIndicationContainer>
            <Bold>{translate(primaryText, { sector })}</Bold>
            <span> - {translate(secondaryText)}</span>
        </MultiLobIndicationContainer>
    );
};

const MultiLobIndicationContainer = styled.div`
    color: ${colorsPalettes.carbon["400"]};
    padding: 10px 25px;
    background-color: #ffdf7c;
    width: 100%;
    max-width: 1368px;
    margin-bottom: 20px;
    font-size: 14px;
    box-sizing: border-box;
    border-radius: 3px;
`;

const Bold = styled.span`
    font-weight: bold;
`;
